import { render, staticRenderFns } from "./SandboxMenuButton.vue?vue&type=template&id=15536123&"
import script from "./SandboxMenuButton.vue?vue&type=script&lang=js&"
export * from "./SandboxMenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports